// extracted by mini-css-extract-plugin
export var accordionItem = "Geo+LsYe";
export var header = "Mu2hJpbJ";
export var title = "Mt4fgV1q";
export var indicator = "+8r3xeOC";
export var content = "uz-MbD3L";
export var active = "ZfoeCkse";